module.exports = __webpack_public_path__ + "static/media/img-works-02.9dc0c5e3.jpg";